const defineHorizonElement = (tagName, klass) => {
  if (!customElements.get(tagName)) {
    customElements.define(tagName, class extends klass {
    });
  }
};
export {
  defineHorizonElement
};
//# sourceMappingURL=define-horizon-element.js.map
